import {withBasicData} from 'core/next/controllers';
import {TAppInitialController} from 'core/redux/types';
import {TGsspData} from 'core/types';
import {breadCrumbsController} from 'modules/breadcrumbs/controller';
import {categoriesRedirectController} from 'modules/categories/controller';
import {CategoryThirdLevelPageProvider} from 'modules/categories/providers/CategoryThirdLevelPageProvider';
import {productControllerByCategory, productControllerBySelection} from 'modules/products/controller';
import {setIsSelection} from 'modules/products/helpers';
import {NextPage} from 'next';

const CatalogPage: NextPage = () => {
    return <CategoryThirdLevelPageProvider />;
};

export const categoryPageController: TAppInitialController<TGsspData> = async (store, ctx) => {
    if (setIsSelection(ctx.query.path)) {
        await Promise.allSettled([breadCrumbsController(store, ctx), productControllerBySelection(store, ctx)]);

        return {
            props: {},
        };
    }
    await categoriesRedirectController(store, ctx);
    await Promise.allSettled([breadCrumbsController(store, ctx), productControllerByCategory(store, ctx)]);

    return {
        props: {},
    };
};

CatalogPage.getInitialProps = withBasicData(categoryPageController);

export default CatalogPage;
